// extracted by mini-css-extract-plugin
module.exports = {"windArrow":"WindArrow_windArrow__udHm5"};